// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '일성아이에스',
  targetSheetName: '수수료율',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '복지부분류',
    '보험코드',
    '제품명',
    '성분명',
    '포장단위',
    '수수료율',
    '약가',
    '생산구분',
    '복지부 분류 코드',
    '성분코드',
    '비고',
  ],
});
